<template>
  <v-container fluid class="fill-height pa-0">
    <v-row class="fill-height" no-gutters>
      <v-col cols="5">
        <v-img :src="url" height="105%" width="105%" class="mt-n2" />
      </v-col>
      <v-col cols="7">
        <v-row no-gutters class="fill-height flex-column flex-nowrap">
          <v-col cols="11" style="max-width: 100%">
            <v-row no-gutters class="justify-center align-center fill-height">
              <v-col cols="8">
                <router-view></router-view>
              </v-col>
            </v-row>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { get, call } from 'vuex-pathify';

export default {
  name: 'LoginWrapper',
  data: () => ({
    url: `${process.env.VUE_APP_API_URL}/settings/theme_picture`,
  }),
  computed: {
    appName: get('admin/settingsValues@app_name'),
  },
  methods: {
    getPublicSettings: call('admin/getPublicSettings'),
    getAdditionalModules: call('admin/getAdditionalModules'),
    async handlePublicSettings() {
      try {
        await this.getPublicSettings();
        document.title = this.appName;
      } catch (error) {
        document.title = 'AQ3.0';
      }
    },
    async handleGetAdditionalModules() {
      try {
        await this.getAdditionalModules(true);
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    this.handlePublicSettings();
    this.handleGetAdditionalModules();
  },
  mounted() {
    this.url = this.url + `?cache=${Date.now()}`;
  },
};
</script>

<style lang="scss" scoped></style>
